<template>
  <div id="content"
       class="container">
    <header class="m15">
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('teacherList')">讲师列表</div>
      </div>
    </header>
    <div class="item-class-show">
      <el-row class="item-class-group"
              style="background:white">
        <el-col class="item-class-name"
                :span="2">
          <span class="book-size">按专业:</span>
        </el-col>
        <el-col class="item-class-name item-class-group"
                :span="22">
          <div v-for="(data,index) in courseList"
               :key="data.id"
               :class="tabIndex===index && !tabSecIndex?'bac':''"
               class="book-item book-size"
               @click="handleSecond(data.id,data.typeName,index)">
            <span>{{data.typeName}}</span>
          </div>
        </el-col>
      </el-row>
      <!-- 二级类目 -->
      <el-row class="item-class-group"
              style="background:white"
              v-if="secondList.length">
        <el-col class="item-class-name"
                :span="2">
          <span class="book-size"></span>
        </el-col>
        <el-col class="item-class-name item-class-group"
                :span="22">
          <div v-for="(data,index) in secondList"
               :key="data.id"
               :class="tabSecIndex===index?'bac':''"
               class="book-item book-size"
               @click="handleCourse(data.id,index)">
            <span>{{data.typeName}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 讲师列表 -->
    <div class="teacher-list">
      <ul>
        <li v-for="(data, index) in teacherList"
            :key="data.id"
            :class="index%4==0? 'course-margin' :''">
          <div class="teacher-info">
            <div class="teacher-img">
              <img :src="data.url?data.url:imgUrl"
                   @click="handleDetail(data.id)" />
            </div>
            <div class="teacher-introduce">
              <h3 @click="handleDetail(data.id)">{{data.name}}</h3>
              <p class="teacher-de">{{data.career}}</p>
            </div>
          </div>
          <div class="teacher-job">
            <p>{{data.education}}</p>
            <p class="findMore"
               @click="handleDetail(data.id)">查看更多
              <img src="@/assets/img/gomore.png"
                   alt=""
                   height="12">
            </p>
          </div>
        </li>
      </ul>
    </div>
    <!-- 分页 -->
    <div class="doclist-pagination"
         v-if="teacherList === [] || teacherList.length !== 0">
      <div class="doclist-lastpage"
           @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':''"
            v-for="(item, index) in pageList"
            :key="index"
            @click="getDataList(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage"
           @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">
        共{{totalPage}}页，到第
        <input type="text"
               v-model.number="jumpTargetPage" />页
      </div>
      <div class="doclist-jump"
           @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      datalist: ['全部', '一级类目', '二级类目', '三级类目', '四级类目', '五级类目'],
      dataForm: {
        type: null
      },
      teacherList: [],
      courseList: [],
      secondList: [],
      pageIndex: 1,
      pageSize: 12,
      totalPage: 0,
      totalData: 0,
      imgUrl: require('@/assets/img/avatar-boy.gif'),
      tabIndex: 0,
      tabSecIndex: '',
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1
    }
  },
  mounted () {
    this.getDataList()
    this.getCourse()
  },
  methods: {
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'teacherList') {
        this.$router.push({ name: 'teacherList' })
      }
    },
    // 讲师列表
    getDataList (page = this.currentPage) {
      this.$http.post(`/front/train/trainTeacher/teacherTypeList`, {
        'page': page,
        'limit': this.pageSize,
        'id': this.dataForm.type
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.teacherList = res.data.data
          this.totalData = res.data.count
          // 分页
          this.totalPage = Math.ceil(res.data.count / 12)
          this.changePageTo(page)
        }
      })
      this.jumpTargetPage = 1
    },
    // 获取课程分类
    getCourse () {
      this.$http.get(`/front/train/trainCourseType/getTree`)
        .then(({ data: res }) => {
          this.courseList = [{ typeName: '全部' }, ...res.data]
        })
    },
    // 获取二级类目
    handleSecond (id, name, index) {
      this.tabIndex = index
      this.tabSecIndex = ''
      this.courseList.forEach(data => {
        if (id === data.id) {
          this.secondList = data.child ? data.child : []
          this.dataForm.type = id
          this.getDataList()
          if (!data.child) {
            this.dataForm.type = id
            this.getDataList()
          }
        }
      })
      if (name === '全部') {
        this.dataForm.type = null
        this.getDataList()
      }
    },
    // 跳转到详情
    handleDetail (id) {
      this.$router.push(
        { name: 'teacherInfo', query: { id: id } }
      )
    },
    handleCourse (id, index) {
      this.tabSecIndex = index
      this.tabIndex = ''
      this.dataForm.type = id
      this.getDataList()
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.getDataList(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.getDataList(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getDataList()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped lang="scss">
.item-class-show{
  padding: 10px;
  background: #fff;
}
.book-size {
  font-size: 14px;
}
.book-item {
  float: left;
  margin: 0 15px 4px 0;
  cursor: pointer;
  padding: 0 15px;
}
// 讲师列表
.teacher-list {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  padding-top: 100px;
}
.teacher-list ul li {
  width: 280px;
  margin-left: 22px;
  height: 240px;
  background: #fff;
  padding: 0 10px;
  float: left;
  margin-bottom: 110px;
}
.teacher-list ul li.course-margin {
  margin-left: 0;
}
.teacher-info {
  width: 100%;
  height: 160px;
  position: relative;
  border-bottom: 1px solid #ccc;
  margin-bottom: 5px;
  padding: 0 5px;
}
.teacher-img {
  width: 140px;
  height: 140px;
  position: absolute;
  background: #fff;
  top: -50%;
  left: 50%;
  margin-left: -70px;
  border-radius: 50%;
  padding: 10px;
}
.teacher-img img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  cursor: pointer;
}
.teacher-introduce {
  width: 100%;
  padding-top: 70px;
  text-align: center;
  font-size: 16px;
  color: #333;
  font-weight: 700;
  text-align: center;
  margin-bottom: 12px;
}
.teacher-introduce h3 {
  color: #333;
  font-size: 16px;
  margin-bottom: 10px;
  cursor: pointer;
  width: 250px;
  height: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.teacher-introduce .teacher-de {
  width: 250px;
  height: 48px;
  color: #999;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.teacher-job p {
  text-align: center;
  color: #999;
  width: 260px;
  height: 21px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.teacher-job .findMore {
  margin-top: 10px;
  color: #1d65a8;
  cursor: pointer;
}
.bac {
  background-color: #1d65a8;
  color: #fff;
}
</style>
